// @flow weak

import React from 'react';

import ErrorBlock from 'app/common/components/ErrorBlock';

const ErrorBlockOrComponent = ({ Component, errorMessage, ...props }) =>
  errorMessage ? (
    <ErrorBlock errorMessage={errorMessage} />
  ) : (
    <Component {...props} />
  );

export default ErrorBlockOrComponent;
